import { Container, Row } from "react-bootstrap";
import "./AboutMe.css";

export default function AboutMe() {
  return (
    <div className="aboutMe mt-5" id="aboutMe">
      <Container>
        <Row>
          <div className="col-md-12 col-12 col-sm-12 pt-4 mb-5  text-center heading">
            <h6>
              <span>ABOUT ME</span>
            </h6>
          </div>
          <div className="col-sm-12  col-12 col-md-12 aboutMeContainer d-flex align-items-center justify-content-center">
            <Row>
              <div data-aos="fade-up" className="mobile text-center col-md-5 col-12 col-sm-12 my-5 aboutMeImg d-flex align-items-center justify-content-center">
                <img src="https://i.ibb.co/zhs0fvX/a1fe2ecf93ee9f9950f9b8d0daddaada.jpg" alt="MyPHOTO" />
              </div>
              <div data-aos="fade-right" className="col-md-7 col-12 col-sm-12 my-5 aboutMeText">
                <p>
                  I am a self-taught, passionate developer. I develop web applications. My key skill in Javascript. I love to do make most of the things using JavaScript. One of
                  the good stuffs as a self-taught web developer is that I have to find the solution myself, which helps me learn more preciously. During my learning process, I
                  have developed numerous skills and strengthened existing abilities, which would serve me well. I can hone my aptitude in new skills very fast.
                </p>
              </div>
              <div data-aos="fade-up" className="desktop col-md-5 col-12 col-sm-12 my-5 aboutMeImg d-flex align-items-center justify-content-center">
                <img src="https://i.ibb.co/zhs0fvX/a1fe2ecf93ee9f9950f9b8d0daddaada.jpg" alt="MyPHOTO" />
              </div>
            </Row>
          </div>
        </Row>
      </Container>
    </div>
  );
}
